import { render } from "./NewOrder.vue?vue&type=template&id=41f3a1f4&ts=true"
import script from "./NewOrder.vue?vue&type=script&lang=ts"
export * from "./NewOrder.vue?vue&type=script&lang=ts"

import "./NewOrder.vue?vue&type=style&index=0&id=41f3a1f4&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__